import React from "react";
import "../Accessories/Accessories.css";
import AccessoriesHero from "../../components/pages/Accessories/AccessoriesHero/AccessoriesHero";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import ContinueExploringCategories from "../../components/pages/AllProducts/ContinueExploringCategories/ContinueExploringCategories";
import DrywallMetalFramesList from "../../components/pages/Accessories/AccessoriesMetals/DrywallMetalFramesList";

const DrywallMetalFrames = () => {
  return (
    <div className="accessories-page">
      <div className="accessories-page-content-guide">
        <Navbar theme="dark" />
        <AccessoriesHero title="Drywall metal frame" imageSlot={1} />
        <DrywallMetalFramesList />
        <ContinueExploringCategories />
      </div>
      <Footer />
    </div>
  );
};

export default DrywallMetalFrames;
